import { all, takeEvery, takeLatest, call, put, throttle } from 'redux-saga/effects'
import { delay } from 'redux-saga';

import { SAGA_GET_POIS, CONCAT_POIS, SAGA_SET_POI_VIEWPORT, 
          SAGA_GET_BOUNDARIES, SET_POI_VIEWPORT, RESET_POIS, 
          SET_BOUNDARIES, CONCAT_BOUNDARIES, RESET_BOUNDARIES } from './actions';
import { sagaGetPOIs, sagaGetBoundaries } from './actions';

import LandmarksAPI from '../shared/api/landmarksid';

function* getPOIs(action){
  if (action.cancelRequest) {
    yield put({
      type: RESET_POIS,
      payload: null,
    });
    return;
  }

  if (action.pageNumber === 0 ){
    yield call(delay, 200);
  }

  const response = yield call(LandmarksAPI.getPOIs, action.payload);
  if (response.error === null){
    const pois = response.json.body;
    
    if (action.payload.pageNumber === 0){
      yield put({
        type: RESET_POIS,
        payload: null,
      });
    }

    yield put({
      type: CONCAT_POIS,
      payload: {
        pois,
      }
    });

    if (pois.length > 0) {
      yield put(sagaGetPOIs(action.payload.topLeft, action.payload.bottomRight, action.payload.organizationIds,
                            action.payload.country, action.payload.pageNumber + 1));
    }
  } else {
    console.log(response);
  }
}

function* getBoundaries(action){
  if (action.cancelRequest) {
    yield put({
      type: RESET_BOUNDARIES,
      payload: null,
    });
    return;
  }

  if (action.payload.page === 0) {
    yield call(delay, 200);
  }

  const response = yield call(LandmarksAPI.getBoundaries, action.payload);
  if (response.error === null){
    const body = response.json.body;

    if (action.payload.page === 0) {
      yield put({
        type: RESET_BOUNDARIES,
        payload: null,
      });
    }
      
    yield put({
      type: CONCAT_BOUNDARIES,
      payload: {
        boundaries: body,
      }
    });

    if (body.length > 0) {
      yield put(sagaGetBoundaries(action.payload.topLeft, action.payload.bottomRight, 
                                  action.payload.boundaryType, 
                                  action.payload.country, action.payload.page + 1));
    }
  } else {
    console.log(response);
  }
}

function* setPOIViewport(action){
  yield put({
    type: SET_POI_VIEWPORT,
    payload: {
      topLeft: action.payload.topLeft,
      bottomRight: action.payload.bottomRight,
    }
  });
}

export default function* poiSagas() {
  yield all([
    takeLatest(SAGA_GET_POIS, getPOIs),
    takeLatest(SAGA_GET_BOUNDARIES, getBoundaries),
  ]);
}



// WEBPACK FOOTER //
// ./src/POI/sagas.js